// extracted by mini-css-extract-plugin
module.exports = {"name":"Filter_name__2T4NQ"};